export default __webpack_public_path__ + "static/media/uploadArea.1539e000.svg";